import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-block d-md-none col-12" }
const _hoisted_2 = { class: "d-flex border-bottom border-bottom-2 border-bottom-primary pb-4" }
const _hoisted_3 = {
  key: 0,
  class: "fa fa-chevron-left fs-2 pe-4 p-1"
}
const _hoisted_4 = { class: "m-auto" }
const _hoisted_5 = {
  class: "d-flex ms-auto",
  style: {"flex":"1"}
}
const _hoisted_6 = {
  key: 0,
  class: ""
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-address-card fs-1 me-4 pt-1" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Personal Info", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-image fs-1 me-4 pt-1" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Profile Photo", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar-xmark fs-1 me-4 pt-1" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Scheduling Conflicts", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-ruler fs-1 me-4 pt-1" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Measurements", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_22 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-hospital fs-1 me-4 pt-1" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Emergency Contacts", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_26 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-address-book fs-1 me-4 pt-1" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Email & Phone Numbers", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_30 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-lock fs-1 me-4 pt-1" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Change Password", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_34 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right-from-bracket fs-1 me-4 pt-1" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Sign Out", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_38 = [
  _hoisted_35,
  _hoisted_36,
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_UserProfileSettings = _resolveComponent("UserProfileSettings")!
  const _component_UserProfilePhotoSettings = _resolveComponent("UserProfilePhotoSettings")!
  const _component_UserEmergencyContactsCard = _resolveComponent("UserEmergencyContactsCard")!
  const _component_UserContactMethodSettings = _resolveComponent("UserContactMethodSettings")!
  const _component_UserChangePasswordSettings = _resolveComponent("UserChangePasswordSettings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "cursor-pointer",
        style: {"flex":"1"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.section = 'main'))
      }, [
        (_ctx.section !== 'main')
          ? (_openBlock(), _createElementBlock("i", _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.section === 'measurements')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "btn-sm ms-auto",
              onClick: _ctx.saveMeasurements
            }, {
              default: _withCtx(() => [
                _createTextVNode("save")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.section === 'main')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTab('personal'))),
            class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary"
          }, _hoisted_10),
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTab('photo'))),
            class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary"
          }, _hoisted_14),
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.navigateToManageConflicts && _ctx.navigateToManageConflicts(...args))),
            class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary"
          }, _hoisted_18),
          _createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToMeasurements && _ctx.goToMeasurements(...args))),
            class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary"
          }, _hoisted_22),
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setTab('emergency'))),
            class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary"
          }, _hoisted_26),
          _createElementVNode("div", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setTab('contact'))),
            class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary"
          }, _hoisted_30),
          _createElementVNode("div", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setTab('password'))),
            class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary d-none"
          }, _hoisted_34),
          _createElementVNode("div", {
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args))),
            class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary"
          }, _hoisted_38)
        ]))
      : _createCommentVNode("", true),
    (_ctx.section === 'personal')
      ? (_openBlock(), _createBlock(_component_UserProfileSettings, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.section === 'photo')
      ? (_openBlock(), _createBlock(_component_UserProfilePhotoSettings, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.section === 'emergency')
      ? (_openBlock(), _createBlock(_component_UserEmergencyContactsCard, { key: 3 }))
      : _createCommentVNode("", true),
    (_ctx.section === 'contact')
      ? (_openBlock(), _createBlock(_component_UserContactMethodSettings, { key: 4 }))
      : _createCommentVNode("", true),
    (_ctx.section === 'password')
      ? (_openBlock(), _createBlock(_component_UserChangePasswordSettings, { key: 5 }))
      : _createCommentVNode("", true)
  ]))
}